import { z } from "zod";
import { PublishedDoc } from "../dsm/published-doc";
import { PublishedDocPage } from "../dsm/published-doc-page";

export const PublishedDocsDump = z.object({
  documentation: PublishedDoc,
  pages: PublishedDocPage.array(),
});

export type PublishedDocsDump = z.infer<typeof PublishedDocsDump>;
